import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductAuthenticationModalComponent } from '@app/+product/components/product-details/product-authentication-modal/product-authentication-modal.component';

@Component({
  selector: 'vc-product-authentication-infos',
  templateUrl: './product-authentication-infos.component.html',
  styleUrls: ['./product-authentication-infos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAuthenticationInfosComponent implements OnInit {
  @Input() isExpressDelivery = false;

  constructor(private dialogService: MatDialog) {}

  ngOnInit() {}

  openAuthenticationModal() {
    this.dialogService.open(ProductAuthenticationModalComponent, {
      maxWidth: 580,
      data: { isExpressDelivery: this.isExpressDelivery }
    });
  }
}
